<template>
    <div class="flex-container" id="login" :style="{height: screenHeight+'px'}">
        <div class="canvaszz" :style="{height: screenHeight+'px'}">
            <video id="movie" autoplay loop muted preload="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/earth.png" x-webkit-airplay="true" x5-playsinline="true" webkit-playsinline="true" playsinline="true" :style="{height: screenHeight+'px'}">
                <source src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/earth_two.mp4" type="video/mp4" />
                抱歉，您的浏览器不支持视频播放
            </video>
            <div class="home_title_content">
                <div class="title_content">
                    <div class="title_name title_name_one">德木云链-木材生意</div>
                    <div class="title_name title_name_two">一站式解决方案服务商</div>
                    <div class="title_explain">“没有企业的时代，只有时代的企业”，这句话恰如其分地指出了优秀卓越 的企业和一般企业的区别，是否能把握住时代趋势，甚至是走在时代的前 沿，德木的使命就是帮助更多企业进化成“时代的企业”。</div>
                    <div class="title_attribute">赋能、协同、共建、共成</div>
                </div>
            </div>
        </div>
        <canvas id="canvas" :style="{height: screenHeight+'px'}"></canvas>
    </div>
</template>
<script>
export default {
    data(){
        return{
           screenHeight: window.innerHeight // 屏幕高度     
        }
    },
    watch:{
        'screenHeight': function (val) { // 监听屏幕高度变化
            var oIframe = document.getElementById('login')
            oIframe.style.height = Number(val) + 'px' // '120'是页面布局调整，可去除
        }
    },
    mounted(){
        var _this = this
        window.onresize = function () { // 定义窗口大小变更通知事件
            _this.screenHeight = document.documentElement.clientHeight // 窗口高度
        }
        var canvas = document.getElementById('canvas')
        var ctx = canvas.getContext('2d')
        var w = canvas.width = window.innerWidth
        var h = canvas.height = window.innerHeight
        var hue = 217
        var stars = []
        var count = 0
        var maxStars = 1300 // 星星数量

        var canvas2 = document.createElement('canvas')
        var ctx2 = canvas2.getContext('2d')
        canvas2.width = 100
        canvas2.height = 100
        var half = canvas2.width / 2
        var gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half)
        gradient2.addColorStop(0.002, '#CCC')
        gradient2.addColorStop(0.1, 'hsl(' + hue + ', 61%, 33%)')
        gradient2.addColorStop(0.25, 'hsl(' + hue + ', 64%, 6%)')
        gradient2.addColorStop(1, 'transparent')

        ctx2.fillStyle = gradient2
        ctx2.beginPath()
        ctx2.arc(half, half, half, 0, Math.PI * 2)
        ctx2.fill()

        // End cache
        function random (min, max) {
            if (arguments.length < 2) {
                max = min
                min = 0
            }
            if (min > max) {
                var hold = max
                max = min
                min = hold
            }
            return Math.floor(Math.random() * (max - min + 1)) + min
        }

        function maxOrbit (x, y) {
        var max = Math.max(x, y)
        var diameter = Math.round(Math.sqrt(max * max + max * max))
        return diameter / 1
        // 星星移动范围，值越大范围越小，
        }

        var Star = function () {
        this.orbitRadius = random(maxOrbit(w, h))
        this.radius = random(60, this.orbitRadius) / 8
        // 星星大小
        this.orbitX = w / 2
        this.orbitY = h / 2
        this.timePassed = random(0, maxStars)
        this.speed = random(this.orbitRadius) / 50000
        // 星星移动速度
        this.alpha = random(2, 10) / 15

        count++
        stars[count] = this
        }

        Star.prototype.draw = function () {
        var x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX
        var y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY
        var twinkle = random(10)

        if (twinkle === 1 && this.alpha > 0) {
            this.alpha -= 0.05
        } else if (twinkle === 2 && this.alpha < 1) {
            this.alpha += 0.05
        }

        ctx.globalAlpha = this.alpha
        ctx.drawImage(canvas2, x - this.radius / 2, y - this.radius / 2, this.radius, this.radius)
        this.timePassed += this.speed
        }

        for (var i = 0; i < maxStars; i++) {
        /* eslint-disable no-new */
        new Star()
        }

        function animation () {
            ctx.globalCompositeOperation = 'source-over'
            ctx.globalAlpha = 0.5 // 尾巴
            ctx.fillStyle = 'hsla(' + hue + ', 64%, 6%, 2)'
            ctx.fillRect(0, 0, w, h)

            ctx.globalCompositeOperation = 'lighter'
            for (var i = 1, l = stars.length; i < l; i++) {
                stars[i].draw()
            };
            window.requestAnimationFrame(animation)
        }
        animation()
        
        
    },
    created(){
        
    },
    methods:{
        addClass (val) {
            document.getElementById(val).style.color = 'black'
        },
        deleteClass (val) {
            document.getElementById(val).style.color = ''
        }
    }
}
</script>
<style scoped  lang="scss">
    canvas {
        width: 100%;
        height: auto /*默认全屏显示 可自己设置高度640px*/;
        display: inline-block;
        vertical-align: baseline;
        position: absolute;
        z-index: -1;
    }
    .canvaszz {
        width: 100%;
        position: absolute;
        background: #000;
        z-index: 2;
        filter: alpha(opacity=80);
        -moz-opacity: 0.8;
        -khtml-opacity: 0.8;
        opacity: 0.8;
        #movie{
            width: 90%;
            margin: 0 auto;
            display: block;
            background: none;
        }
        .home_title_content{
            width: 100%;
            height: 100%;
            color: #fff;
            position: absolute;
            left: 0;
            top: 0;
            .title_content{
                width: 60rem;
                height: 50rem;
                transform: translateX(-50%) translateY(-50%);
                position: absolute;
                left: 50%;
                top: 50%;
                z-index: 10;
                padding-top: 6rem;
                .title_name{
                    font-size: 4.5rem;
                }
                .title_name_two{
                    text-align: right;
                }
                .title_explain{
                    margin-top: 6rem;
                    font-size: 1.4rem;
                    line-height: 2rem;
                    letter-spacing:0.2rem;
                }
                .title_attribute{
                    text-align: center;
                    margin-top: 8rem;
                    font-size: 3rem;
                }
            }
        }
    }
</style>